import { Component, Input } from '@angular/core';

@Component({
    selector: 'loader',
    templateUrl: './loader.component.html',
    styleUrls: [
        'loader.component.scss'
    ]
})
export class LoaderComponent {
    @Input() loading;
}



// WEBPACK FOOTER //
// /codebuild/output/src2645790472/src/src/app/shared/components/loader/loader.component.ts